export default __webpack_public_path__ + "static/media/emailLogo.2a8693d3.png";